import t, { useRef as B, useState as F } from "react";
import { cls as O } from "../../helpers/cls.js";
import { runInputValidations as L } from "../../helpers/inputValidation.js";
import { Flex as P } from "../Flex/Flex.js";
import { Spinner as T } from "../Spinner/Spinner.js";
import { useUniqueId as b } from "../../hooks/useUniqueId.js";
import { Chip as V } from "../Chip/Chip.js";
import { X as z } from "@olxbr/ds-icons";
import { InputChipsDefaultProps as h } from "./props.js";
import { FormControl as M, FormControlLabel as W, FormControlErrorORCaption as q } from "../FormControl/FormControl.js";
typeof window != "undefined" && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = "3.35.0");
const v = x => {
  const {
    id: s,
    label: m,
    placeholder: I,
    "aria-label": f,
    value: D = h.value,
    link: C,
    disabled: c,
    disableBackspaceChipRemove: S = h.disableBackspaceChipRemove,
    separatorCode: w = h.separatorCode,
    state: i,
    stateMessage: p,
    caption: E,
    onChange: o,
    onChipRemove: g
  } = x;
  L({
    "aria-label": f,
    id: s,
    label: m,
    state: i,
    stateMessage: p
  });
  const R = b("ds-inputchips-element"),
    u = s != null ? s : R,
    k = b("ds-inputchips-error"),
    y = B(null),
    [n, d] = F(D),
    N = (e, l) => {
      e.stopPropagation();
      const r = n.filter(a => a !== l) || [];
      d(r), o == null || o(r), g == null || g(l);
    },
    $ = e => {
      e.stopPropagation();
      const l = e.currentTarget.value;
      if (!l && n.length && e.key === "Backspace") {
        e.currentTarget.value = S ? "".concat(n.slice(-1), " ") : "";
        const a = [...n.slice(0, -1)];
        d(a), o == null || o(a);
      }
      const r = l == null ? void 0 : l.trim();
      if (r != null && r.length && [e == null ? void 0 : e.code, e == null ? void 0 : e.key].some(a => a === w)) {
        if (e.preventDefault(), n.includes(r)) return;
        const a = [...n, r];
        d(a), o == null || o(a), e.currentTarget.value = "";
      }
    },
    _ = i === "error" && !!p && !c;
  return t.createElement(P, {
    "data-ds-component": "DS-InputChips",
    flexDirection: "column"
  }, (!!m || C) && t.createElement(M, {
    marginBottom: "--spacing-1"
  }, t.createElement(W, {
    size: "medium",
    htmlFor: s
  }, m), C), t.createElement("span", {
    className: O("olx-input-chips__content", c && "olx-input-chips__content--disabled", i && "olx-input-chips__content--".concat(i), (n == null ? void 0 : n.length) > 0 && "olx-input-chips__content--has-content"),
    id: "".concat(u, "-wrapper")
  }, n.map(e => t.createElement(V, {
    key: "".concat(u, "-").concat(e),
    className: "olx-input-chips__chip",
    disabled: c,
    onClick: l => N(l, e),
    "aria-label": "Remover ".concat(e)
  }, e, t.createElement(z, null))), t.createElement("input", {
    className: "olx-input-chips__input",
    "data-ds-component": "DS-InputChips-Input",
    ref: y,
    id: "".concat(u, "-input"),
    type: "text",
    placeholder: I,
    "aria-label": f,
    "aria-busy": i === "loading",
    "aria-invalid": i === "error",
    disabled: c,
    autoComplete: "off",
    onKeyDown: $
  }), i === "loading" && t.createElement("span", {
    className: "olx-input-chips__icon-wrapper"
  }, t.createElement(T, {
    "aria-label": p != null ? p : "",
    size: "extra-small"
  }))), (!!E || _) && t.createElement(q, {
    marginTop: "--spacing-1",
    hasError: _,
    id: k
  }, _ ? p : E));
};
v.displayName = "InputChips";
export { v as InputChips };